"use client";

import { motion, useReducedMotion } from "framer-motion";

import { CELL, CELL_OPACITY } from "./motion";

// The uptime strip: twelve filled squares, one per month of the year. A plain
// 12-column grid rather than fixed 24px boxes, so the row always spans the tile
// exactly as it does in the design, at any width.
//
// The squares fill in month by month. The resting opacity is the animation's
// end value rather than a class, since the two would otherwise fight.
export default function UptimeGrid({ delay = 0 }) {
  const reduce = useReducedMotion();

  return (
    <div aria-hidden="true" className="grid w-full grid-cols-12 gap-1">
      {Array.from({ length: 12 }, (_, i) => (
        <motion.span
          key={i}
          className="aspect-square rounded-md bg-green-500"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: CELL_OPACITY, scale: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{
            duration: reduce ? 0 : CELL.duration,
            delay: reduce ? 0 : delay + i * CELL.stagger,
            ease: CELL.ease,
          }}
        />
      ))}
    </div>
  );
}
